/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateEnduserDelegateAdminPayload } from '../model/createEnduserDelegateAdminPayload';
import { EnduserDelegateData } from '../model/enduserDelegateData';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class DelegateAdminService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Create enduser delegate
     * 
     * @param payload Enduser delagation to be created
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createEnduserDelegateAdmin(payload?: CreateEnduserDelegateAdminPayload, observe?: 'body', reportProgress?: boolean): Observable<EnduserDelegateData>;
    public createEnduserDelegateAdmin(payload?: CreateEnduserDelegateAdminPayload, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EnduserDelegateData>>;
    public createEnduserDelegateAdmin(payload?: CreateEnduserDelegateAdminPayload, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EnduserDelegateData>>;
    public createEnduserDelegateAdmin(payload?: CreateEnduserDelegateAdminPayload, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EnduserDelegateData>(`${this.basePath}/api/endusers/admin/delegates`,
            payload,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete enduser delegate
     * 
     * @param beginOn Begin time
     * @param enduserId Enduser
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteEnduserDelegateAdmin(beginOn: string, enduserId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteEnduserDelegateAdmin(beginOn: string, enduserId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteEnduserDelegateAdmin(beginOn: string, enduserId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteEnduserDelegateAdmin(beginOn: string, enduserId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (beginOn === null || beginOn === undefined) {
            throw new Error('Required parameter beginOn was null or undefined when calling deleteEnduserDelegateAdmin.');
        }

        if (enduserId === null || enduserId === undefined) {
            throw new Error('Required parameter enduserId was null or undefined when calling deleteEnduserDelegateAdmin.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/endusers/admin/delegates/${encodeURIComponent(String(enduserId))}/${encodeURIComponent(String(beginOn))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Search enduser delegate
     * 
     * @param enduserId Enduser
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEnduserDelegateAdminList(enduserId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<EnduserDelegateData>>;
    public getEnduserDelegateAdminList(enduserId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<EnduserDelegateData>>>;
    public getEnduserDelegateAdminList(enduserId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<EnduserDelegateData>>>;
    public getEnduserDelegateAdminList(enduserId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (enduserId === null || enduserId === undefined) {
            throw new Error('Required parameter enduserId was null or undefined when calling getEnduserDelegateAdminList.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<EnduserDelegateData>>(`${this.basePath}/api/endusers/admin/delegates/${encodeURIComponent(String(enduserId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
